import { flattenExtensions, generateHTML, resolveExtensions } from '@tiptap/core';
import { MarkdownManager } from '@tiptap/markdown';
import { isString } from 'lodash';
import { createRichTextExtensions } from './rich-text-extensions';
import { isRichTextHTML, sanitizeRichTextHTML } from './rich-text-sanitizer';

let renderer: { manager: MarkdownManager; extensions: ReturnType<typeof createRichTextExtensions> } | undefined;

function getRenderer() {
  if (!renderer) {
    const extensions = createRichTextExtensions();
    renderer = {
      extensions,
      // Single line breaks are shown as breaks, matching how notes looked when written
      manager: new MarkdownManager({
        markedOptions: { breaks: true },
        extensions: flattenExtensions(resolveExtensions(extensions)),
      }),
    };
  }
  return renderer;
}

// Converts stored rich text (markdown, or HTML saved with outputType="html") into sanitised HTML for display
export function richTextToHtml(value: string): string {
  if (!isString(value) || !value.trim()) return '';
  if (isRichTextHTML(value)) return showTaskStates(sanitizeRichTextHTML(value));

  const { manager, extensions } = getRenderer();
  return showTaskStates(sanitizeRichTextHTML(generateHTML(manager.parse(value), extensions)));
}

// Angular's [innerHTML] sanitiser removes every <input>, which would lose whether a task is ticked, so show it as text.
// This also keeps the state in plain text copied from the HTML.
function showTaskStates(html: string): string {
  if (!html.includes('type="checkbox"')) return html;

  const doc = new DOMParser().parseFromString(html, 'text/html');
  doc.body.querySelectorAll<HTMLInputElement>('input[type="checkbox"]').forEach((box) => {
    box.replaceWith(doc.createTextNode(box.hasAttribute('checked') ? '☑' : '☐'));
  });
  return doc.body.innerHTML;
}
